(function ($) {
    $('.header__nav__toggle').on('click', function () {
        $(this).next('.menu').find('> ul').fadeToggle('fast');
        $(this).toggleClass('open');
    });
}(jQuery))
